import { RISK_DATA_UI } from './dataUI.const';

/**
 * Helper para obtener configuración de UI por tipo de riesgo
 */
const getRiskUIConfig = (tipo: string) => {
  return RISK_DATA_UI.find((risk) => risk.label === tipo) || RISK_DATA_UI[4]; // 'otro' por defecto
};

/**
 * Configuración de notificaciones por tipo
 * Usa colores de RISK_DATA_UI para consistencia visual
 */
export const NOTIFICATION_CONFIG: Record<
  string,
  {
    message: string;
    actionUrl: string;
    icon: any;
    colorText: string;
    colorBg: string;
    colorBorder: string;
  }
> = {
  asistencia: {
    message: 'Revisar riesgos académicos de asistencia',
    actionUrl: '/riesgo-academico',
    icon: getRiskUIConfig('asistencia').icon,
    colorText: getRiskUIConfig('asistencia').colorText,
    colorBg: getRiskUIConfig('asistencia').colorBg,
    colorBorder: getRiskUIConfig('asistencia').colorBorder,
  },
  nota: {
    message: 'Revisar riesgos académicos de notas',
    actionUrl: '/riesgo-academico',
    icon: getRiskUIConfig('nota').icon,
    colorText: getRiskUIConfig('nota').colorText,
    colorBg: getRiskUIConfig('nota').colorBg,
    colorBorder: getRiskUIConfig('nota').colorBorder,
  },
  beneficio: {
    message: 'Revisar riesgos académicos de beneficios',
    actionUrl: '/riesgo-academico',
    icon: getRiskUIConfig('beneficio').icon,
    colorText: getRiskUIConfig('beneficio').colorText,
    colorBg: getRiskUIConfig('beneficio').colorBg,
    colorBorder: getRiskUIConfig('beneficio').colorBorder,
  },
  social: {
    message: 'Revisar Riesgos académicos de socioeconómico',
    actionUrl: '/riesgo-academico',
    icon: getRiskUIConfig('social').icon,
    colorText: getRiskUIConfig('social').colorText,
    colorBg: getRiskUIConfig('social').colorBg,
    colorBorder: getRiskUIConfig('social').colorBorder,
  },
  otro: {
    message: 'Revisar otros riesgos académicos',
    actionUrl: '/riesgo-academico',
    icon: getRiskUIConfig('otro').icon,
    colorText: getRiskUIConfig('otro').colorText,
    colorBg: getRiskUIConfig('otro').colorBg,
    colorBorder: getRiskUIConfig('otro').colorBorder,
  },
};

/**
 * Configuración por defecto para tipos no mapeados
 */
export const DEFAULT_NOTIFICATION_CONFIG = {
  message: 'Revisar pendientes en riesgos académicos',
  actionUrl: '/riesgo-academico',
  icon: getRiskUIConfig('otro').icon,
  colorText: getRiskUIConfig('otro').colorText,
  colorBg: getRiskUIConfig('otro').colorBg,
  colorBorder: getRiskUIConfig('otro').colorBorder,
};
